import React, { useEffect, useState } from "react";
import { getUserProfile } from "../utilities/axios.utilities";
import { getAssetUrl } from "../utils/assetUrl";
import "./AppHeaderBar.css";

interface IProps {
  setIsShowLogout: () => void;
}

function formatToken(n: number | undefined): string {
  if (n == null || Number.isNaN(n)) return "0";
  return n.toLocaleString("vi-VN");
}

const Header: React.FC<IProps> = ({ setIsShowLogout }) => {
  const userInfoString = localStorage.getItem("user_info");
  const userInfo = userInfoString ? JSON.parse(userInfoString) : null;

  const [userProfile, setUserProfile] = useState<any>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getUserProfile();
        setUserProfile(data);
        let prev: Record<string, unknown> = {};
        try {
          prev = JSON.parse(localStorage.getItem("user_info") || "{}");
        } catch {
          prev = {};
        }
        localStorage.setItem(
          "user_info",
          JSON.stringify({
            ...prev,
            userName: data.username,
            coins: data.coins,
            role: data.role,
            id: data._id ?? prev.id,
          })
        );
      } catch (err) {
        console.error("Error fetching user profile:", err);
      }
    };

    fetchProfile();
  }, []);

  const displayName =
    userProfile?.username ?? userInfo?.userName ?? "—";
  const coins = userProfile?.coins ?? userInfo?.coins ?? 0;

  return (
    <div className="app-header-wrap">
      <header className="app-header-bar" role="banner">
        <img
          className="app-header-bar__brand-logo"
          src={getAssetUrl("/assets/logo.png")}
          alt="A.I Tool VIP XX88D"
          width={391}
          height={66}
        />

        <div className="app-header-bar__right">
          <div className="app-header-bar__pill app-header-bar__pill--user">
            <img
              className="app-header-bar__pill-icon"
              src={getAssetUrl("/assets/icon-user.png")}
              alt=""
              width={32}
              height={32}
              aria-hidden
            />
            <span className="app-header-bar__pill-text app-header-bar__pill-text--user">
              {displayName}
            </span>
          </div>

          <div className="app-header-bar__pill app-header-bar__pill--coins">
            <img
              className="app-header-bar__pill-icon"
              src={getAssetUrl("/assets/icon-coin.png")}
              alt=""
              width={32}
              height={32}
              aria-hidden
            />
            <span className="app-header-bar__pill-text app-header-bar__pill-text--coins">
              {formatToken(coins)}
            </span>
          </div>

          <button
            type="button"
            className="app-header-bar__pill app-header-bar__pill--logout"
            onClick={setIsShowLogout}
          >
            <img
              className="app-header-bar__pill-icon"
              src={getAssetUrl("/assets/icon-logout.png")}
              alt=""
              width={32}
              height={32}
              aria-hidden
            />
            <span className="app-header-bar__pill-text app-header-bar__pill-text--logout">
              Đăng xuất
            </span>
          </button>
        </div>
      </header>
    </div>
  );
};

export default Header;
